// One incident or maintenance window on the public status page, with every
// update (TOM-930, cloud ADR 0453). Reads only /v1/status/incidents/:id.

import { Link, useParams } from 'react-router-dom';

import {
  COMPONENT_NAMES,
  IMPACT_LABELS,
  INCIDENT_STATE_LABELS,
  formatInstant,
} from '../lib/statusPage';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { useIncident } from '../lib/useStatusPage';

export function StatusIncident() {
  const { id } = useParams<{ id: string }>();
  const state = useIncident(id);
  useDocumentTitle(state.kind === 'ready' ? `Neomaris | ${state.data.title}` : 'Neomaris | Status');

  return (
    <section className="status-page" aria-labelledby="status-incident-title">
      <p>
        <Link className="link" to="/status">
          ← Neomaris status
        </Link>
      </p>
      {state.kind === 'loading' && <p className="status-note">Loading…</p>}
      {state.kind === 'missing' && (
        <p className="status-note" role="alert">
          There is no such incident.
        </p>
      )}
      {state.kind === 'error' && (
        <p className="status-note" role="alert">
          We couldn&apos;t load this incident just now.
        </p>
      )}
      {state.kind === 'ready' && (
        <>
          <header className="status-head">
            <h1 id="status-incident-title">{state.data.title}</h1>
            <p className="status-incident__meta">
              <span
                className={`tb-chip tb-chip--${
                  state.data.impact === 'major'
                    ? 'bad'
                    : state.data.impact === 'minor'
                      ? 'warn'
                      : 'accent'
                }`}
              >
                {state.data.kind === 'maintenance'
                  ? 'Maintenance'
                  : `${IMPACT_LABELS[state.data.impact]} incident`}
              </span>
              <span className="tb-chip">{INCIDENT_STATE_LABELS[state.data.state]}</span>
            </p>
            <p className="status-muted">
              {state.data.components.map((c) => COMPONENT_NAMES[c]).join(', ')} ·{' '}
              {formatInstant(state.data.startsAt)}
              {state.data.endsAt !== null ? ` to ${formatInstant(state.data.endsAt)}` : ''}
            </p>
          </header>
          <ol className="tb-card status-timeline">
            {[...state.data.updates].reverse().map((u) => (
              <li key={u.id} className="status-timeline__item">
                <div className="status-timeline__state">{INCIDENT_STATE_LABELS[u.state]}</div>
                <p>{u.body}</p>
                <div className="status-muted">{formatInstant(u.createdAt)}</div>
              </li>
            ))}
          </ol>
        </>
      )}
    </section>
  );
}
